<p>{{ data.label }}</p>

<div class="buttons">
  <button mat-stroked-button class="gray-2" (click)="close()">cancelar</button>
  <button mat-raised-button class="primary-1" (click)="close('SUBMITTED')"
    [ngClass]="{'alert': data.confirmBtnClass === 'alert'}">
    confirmar
  </button>
</div>
